exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rexer_event-contact a[data-v-97453d20]{color:#fff;display:flex;align-items:center;line-height:1.3;padding:0.5rem 0;font-size:1rem}.rexer_event-contact a[data-v-97453d20]:hover,.rexer_event-contact a[data-v-97453d20]:focus,.rexer_event-contact a[data-v-97453d20]:active{color:lime;outline:0 none}.rexer_event-contact span[data-v-97453d20]{display:inline-block}.rexer_event-contact__icon[data-v-97453d20]{width:1.5rem;height:auto;display:flex;justify-content:center;align-items:center;margin-right:0.5rem}.rexer_event-contact__icon svg[data-v-97453d20]{width:1em;height:1em}\n", ""]);

// exports
